import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { apiClient } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cims_token');
    const savedUser = localStorage.getItem('cims_user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const { data } = await apiClient.post('/api/auth/login', { username, password });
    localStorage.setItem('cims_token', data.token);
    localStorage.setItem('cims_user', JSON.stringify(data.user));
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setUser(data.user);
    return data.user;
  };

  const refreshProfile = async () => {
    const { data } = await apiClient.get('/api/auth/profile');
    localStorage.setItem('cims_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const updateProfile = async (payload) => {
    const { data } = await apiClient.put('/api/auth/profile', payload);
    localStorage.setItem('cims_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await apiClient.post('/api/auth/register', payload);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('cims_token');
    localStorage.removeItem('cims_user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  // An expired token (8 h) or an account deactivated by an admin answers
  // 401 on every call; sign out cleanly instead of leaving a half-working
  // screen. Wrong-password answers from the login form are not affected:
  // that request carries no token.
  useEffect(() => {
    const onError = error => {
      const sentToken = error.config?.headers?.Authorization || error.config?.headers?.authorization;
      if (error.response?.status === 401 && sentToken && localStorage.getItem('cims_token')) {
        localStorage.removeItem('cims_token');
        localStorage.removeItem('cims_user');
        delete axios.defaults.headers.common['Authorization'];
        setUser(null);
      }
      return Promise.reject(error);
    };
    // apiClient is the same axios instance, so one interceptor covers both.
    const id = axios.interceptors.response.use(response => response, onError);
    return () => axios.interceptors.response.eject(id);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading, refreshProfile, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
